import { HttpClient } from '@opallabs/api'

const destroyReaction = ({ reactionId, onDeleteSuccess = () => null }) => {
  const url = `/reactions/v2/${reactionId}`
  return HttpClient()
    .delete(url)
    .then((reactionResponse) => onDeleteSuccess(reactionResponse.data))
}

export default destroyReaction
